const T_PREFIX = "my-clones";

export const myClonesTrns = {
  createCloneButton: `${T_PREFIX}.create-clone-btn`,

  whatDoYouWantToCloneTitle: `${T_PREFIX}.create.what-do-you-want-to-clone.title`,
  tellUsAboutYourBusinessTitle: `${T_PREFIX}.create.tell-us-about-your-business.title`,

  doYouWantChangeCloneTypeTitle: `${T_PREFIX}.edit.do-you-want-change-clone-type.title`,
  changeInformationAboutYourBusinessTitle: `${T_PREFIX}.edit.change-information-about-your-business.title`,
};

export const myClonesSortingTrns = {
  allOptionlabel: `${T_PREFIX}.sorting.options.all-label`,
  activeOptionlabel: `${T_PREFIX}.sorting.options.active-label`,
  pausedOptionlabel: `${T_PREFIX}.sorting.options.paused-label`,
};

export const emptyCloneListTrns = {
  title: `${T_PREFIX}.empty-clone-list.title`,
  description: `${T_PREFIX}.empty-clone-list.description`,
};
